export const ORANGE = "#e95832"
export const BLACK = "#292f36"
